import { isBarberSessionView } from '../../../../infra/session';
import { getUrlPrefixFromView } from '../../../../infra/routing';
export var getUpdateDetailsUrl = function (session, optInByDefault) {
    if (optInByDefault === void 0) { optInByDefault = false; }
    var urlPrefix = getUrlPrefixFromView(session.view);
    var url = "".concat(urlPrefix, "/settings/user");
    if (optInByDefault) {
        url = "".concat(url, "?optInForTwoFaByDefault=true");
    }
    return url;
};
export var canSeeTwoFaOptInModal = function (session, featureFlags) {
    return featureFlags['2FaEnable'] && featureFlags['2FaPhaseOne'] && isBarberSessionView(session.view);
};
export var canSeeTwoFaComingSoonModal = function (session, featureFlags) {
    return (!canSeeTwoFaOptInModal(session, featureFlags) && featureFlags['2FaEnableAnnouncement'] && featureFlags['2FaEnable']);
};
